import {atom, selector} from 'recoil';

const emojisState = atom({
  key: 'emojisState',
  default: [],
});

export const limitedEmojiState = selector({
  key: 'limitedEmojiState',
  get: ({get}) => {
    return get(emojisState).slice(0, 30);
  }
})

export default emojisState;
